import { render, staticRenderFns } from "./DetailBasic.vue?vue&type=template&id=27bc02fd&scoped=true&"
import script from "./DetailBasic.vue?vue&type=script&lang=js&"
export * from "./DetailBasic.vue?vue&type=script&lang=js&"
import style0 from "./DetailBasic.vue?vue&type=style&index=0&id=27bc02fd&prod&lang=sass&scoped=true&"
import style1 from "./DetailBasic.vue?vue&type=style&index=1&id=27bc02fd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bc02fd",
  null
  
)

export default component.exports